var map = {
	"./Asur Bgm.mp3": 13,
	"./Boney M  Rasputin Official Instrumental HQ.mp3": 5325,
	"./Clarx - Shakedown [NCS Release].mp3": 6526,
	"./Gasolina.mp3": 2705,
	"./Heuse & Tom Wilson - Ignite [NCS Release].mp3": 1374,
	"./JVSTIN  CLANDESTINA.mp3": 9011,
	"./Kenny G  The Moment Official Video.mp3": 5053,
	"./MONTAGEM ORQUESTRA.mp3": 9065,
	"./Mahabharat ki katha.mp3": 7484,
	"./Midranger - Apocalypse [NCS Release].mp3": 4968,
	"./N3WPORT - Alive (feat. Neoni) [NCS Release].mp3": 8657,
	"./NF  The Search lyrics.mp3": 5362,
	"./ROY KNOX -  Over My Head (Feat. Mike Robert) [NCS Release].mp3": 3664,
	"./Subtact - Want You (feat. Sara Skinner) [NCS Release].mp3": 3193,
	"./Tesher x Jason Derulo  Jalebi Baby.mp3": 2848,
	"./file_example_MP3_1MG.mp3": 2309,
	"./file_example_MP3_5MG.mp3": 5361,
	"./impact.mp3": 1688,
	"./impact2.mp3": 1313,
	"./mixkit-games-worldbeat-466.mp3": 1668
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6032;